var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bnb-bnb-logo 1",
    clipPath: "url(#clip0_721_26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.62 16.3881L18.9999 8.814L26.3833 16.3914L30.6773 11.9844L18.9999 0L7.32637 11.9808L11.6202 16.3878M0 19.5L4.29414 15.0922L8.58797 19.4991L4.29383 23.9062L0 19.5ZM11.62 22.6124L18.9999 30.186L26.3831 22.6088L30.6794 27.0134L30.6773 27.0158L18.9999 39L7.32637 27.0192L7.32029 27.013L11.6205 22.6119M29.4119 19.5019L33.706 15.0947L37.9998 19.5016L33.7059 23.9087L29.4119 19.5019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3552 19.4977H23.357L19.0001 15.0258L15.7797 18.33L15.4097 18.7099L14.6467 19.4931L14.6406 19.4992L14.6467 19.5056L19.0001 23.9742L23.3573 19.5023L23.3595 19.4999L23.3555 19.4977",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.b93b80376e6dfdc94597ae9328cd4ae6.svg";
export { ForwardRef as ReactComponent };